import React, { useState } from 'react'
import {
  SearchHeroWrapper,
  SearchHeroWrapperInner,
  SearchHeroHeading
} from './SearchHeroWrapper'
import { FormWrapper, FormSelectFieldWrapper, Separator } from './FormWrapper'
import { navigate } from 'gatsby'
import { isCar, isVan } from '../../../../lib/category-matcher'
import UsedNewButtons, { SearchButton } from './Buttons'
import buildPath from '../../../../lib/cars/used/path-builder'
import { BrandGrid } from '../../../components/PrimaryActions/components/BrandGrid'
import { SelectField } from './SelectField'
import IconChevron from '../../../vectors/IconChevron'

const SearchHeroWidget = (props) => {
  const { vehicleType } = props

  const isCategory = vehicleType === 'cars' ? isCar : isVan

  const [type, setType] = useState('used')
  const [make, setMake] = useState('')
  const [model, setModel] = useState('')

  const changeType = (type) => {
    setType(type)
    setMake('')
    setModel('')
  }

  let makes = []
  let models = []

  if (type === 'used') {
    const collatedMakes = props.usedVehicles.reduce((acc, vehicle) => {
      if (!isCategory(vehicle.category)) return acc

      const index = acc.findIndex((item) => item.make === vehicle.brand)

      if (index === -1) {
        acc.push({
          make: vehicle.brand,
          models: [
            {
              model: vehicle.model,
              count: 1
            }
          ],
          count: 1
        })
      } else {
        const modelIndex = acc[index].models.findIndex(
          (item) => item.model === vehicle.model
        )

        if (modelIndex === -1) {
          acc[index].models.push({
            model: vehicle.model,
            count: 1
          })
        } else {
          acc[index].models[modelIndex].count++
        }
        acc[index].count++
      }

      return acc
    }, [])

    makes = collatedMakes
      .sort((a, b) => b.count - a.count)
      .map((item) => ({
        label: item.make,
        count: item.count,
        value: item.make
      }))

    if (make) {
      const index = collatedMakes.findIndex((item) => item.make === make)
      models = collatedMakes[index].models
        .sort((a, b) => b.count - a.count)
        .map((item) => ({
          label: item.model,
          count: item.count,
          value: item.model
        }))
    }
  } else {
    makes = props.makes.reduce((acc, make) => {
      if (!isCategory(make.category)) return acc

      acc.push({
        label: `${make.name}`,
        id: make._id,
        value: make.slug
      })

      return acc
    }, [])

    if (make) {
      const makeItem = makes.find((item) => item.value === make)
      models = props.allModels.reduce((acc, model) => {
        if (model.make !== makeItem.id) return acc
        if (model.parentModel) return acc

        acc.push({
          label: `${model.name}`,
          id: model._id,
          value: model.slug
        })

        return acc
      }, [])
    }
  }

  const selectedMake = makes.find((item) => item.value === make)
  const selectedModel = models.find((item) => item.value === model)

  let numberOfVehicles = selectedModel
    ? selectedModel.count
    : selectedMake
    ? selectedMake.count
    : ''

  const handleSearch = () => {
    const category = vehicleType === 'cars' ? 'car' : 'van'

    if (type === 'used') {
      const path = buildPath(category, {
        brand: make,
        model
      })

      navigate(path)
    } else {
      let path = `/${make}`
      if (model) {
        path += `/${model}`
      }

      if (!make && !model) {
        path = `/${vehicleType}/new`
      }

      navigate(path)
    }
  }

  return (
    <SearchHeroWrapper>
      <SearchHeroWrapperInner>
        <SearchHeroHeading>
          Discover automotive excellence: <br /> New & Used vehicles from the
          best brands
        </SearchHeroHeading>
        <FormWrapper>
          <UsedNewButtons type={type} setType={changeType} />
          <Separator />
          <FormSelectFieldWrapper>
            <SelectField
              value={make}
              onChange={(e) => setMake(e.target.value)}
              disabled={makes.length === 0}
              label="Make"
              options={[
                { label: 'Select preferred make', value: '' },
                ...makes
              ]}
            />
            <Separator />
            <SelectField
              value={model}
              onChange={(e) => setModel(e.target.value)}
              disabled={models.length === 0}
              label="Model"
              options={[
                { label: 'Select specific model', value: '' },
                ...models
              ]}
            />
          </FormSelectFieldWrapper>
          <Separator />

          <SearchButton onClick={handleSearch}>
            <span>
              Search {numberOfVehicles} {vehicleType}
            </span>
            <IconChevron />
          </SearchButton>
        </FormWrapper>

        <BrandGrid white />
      </SearchHeroWrapperInner>
    </SearchHeroWrapper>
  )
}

export default SearchHeroWidget
